import { qiniuImageView as qiv } from '@/utils/common'

export const qiniuImageView = (value, ...args) => {
    return qiv.apply(null, [value, ...args])
}

export default {
    qiniuImageView,
}